<template>
    <v-date-picker v-model="date" no-title color="primary" v-bind="{ ...$attrs, dayFormat, allowedDates }" @update:picker-date="changeMonth" />
</template>

<script>
import dayjs from "dayjs";
export default {
    props: {
        value: { type: String, default: dayjs().add(1, "day").format("YYYY-MM-DD") },
    },
    data: () => ({
        date: dayjs().add(1, "day").format("YYYY-MM-DD"),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        date() {
            this.emit();
        },
    },
    methods: {
        sync() {
            this.date = this.value || dayjs().add(1, "day").format("YYYY-MM-DD");
        },

        emit() {
            this.$emit("input", this.date);
        },

        changeMonth(date) {
            let month = date.split("-")[1];
            let today = dayjs().format("YYYY-MM-DD");
            if (month == today.split("-")[1]) {
                this.date = today;
            } else {
                this.date = dayjs(date).startOf("month").format("YYYY-MM-DD");
            }
        },

        dayFormat(date) {
            return dayjs(date).get("date");
        },

        allowedDates(date) {
            return !dayjs(date).isBefore(dayjs().add(1, "day"), "date") && dayjs().add(60, "days").isAfter(date, "date");
        },
    },
};
</script>

<style>
.v-picker.v-card.v-picker--date.v-sheet--outlined {
    width: 100%;
}
.theme--light.v-date-picker-table th {
    color: #131313;
}
.v-date-picker-table .theme--light.v-btn.v-btn--disabled {
    color: #95a2aa !important;
}
.v-date-picker-header {
    justify-content: center;
    margin-bottom: 12px;
}
.v-date-picker-header__value {
    flex: unset;
    width: 160px;
}
.v-date-picker-header .theme--light.v-btn.v-btn--icon {
    border: 1px solid #d2dee4;
}
.v-date-picker-header .v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0;
}
.v-date-picker-header .theme--light.v-btn.v-btn--icon i::before {
    color: #95a2aa;
}
.theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {
    color: #131313;
}
.v-btn:not(.v-btn--outlined).primary {
    color: #fff !important;
}
.v-date-picker-table th {
    font-weight: 700;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .v-date-picker-header {
        margin-bottom: 35px;
    }
    .theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button {
        font-size: 2.2rem;
    }
    .v-date-picker-table th {
        font-size: 1.8rem;
        padding: 25px 0;
    }
    .v-date-picker-table td {
        padding: 15px 0;
    }
    .v-date-picker-table .v-btn {
        font-size: 18px;
        width: 42px;
        height: 42px;
    }
}
@media (min-width: 1200px) {
}
</style>
